import classNames from 'classnames';
import { arrayOf, bool, func, oneOfType, string } from 'prop-types';
import React, { useState } from 'react';
import { Modal } from '@eika/modal';
import { Icon, IconTypes } from '@eika/icon';
import ErrorMessage from '../../errormessage';

const RadioInput = ({
    id,
    name,
    onChange,
    labels,
    value,
    values,
    className,
    heading,
    errorText,
    tooltipText,
    modalHelpBody,
    modalHelpHeader,
    isDisabled,
    appNamespace,
}) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    let tooltipBox;
    let tooltipIcon;
    let modalBox;

    const onToggleTooltip = (event) => {
        event.preventDefault();
        setTooltipOpen(!tooltipOpen);
    };

    const onToggleModal = (event) => {
        event.preventDefault();
        setModalOpen(!modalOpen);
    };

    if (tooltipText && tooltipOpen) {
        tooltipBox = (
            <div className="input-tooltip">
                <div className="arrow" />
                <div className="input-tooltip-box">
                    <div>{tooltipText}</div>
                    <button type="button" className="btn-transparent input-label-close" onClick={onToggleTooltip}>
                        <span className="ikon-kryss-24 input-label-close-x" aria-hidden />
                        <span className="input-label-close-text">Lukk</span>
                    </button>
                </div>
            </div>
        );
    }

    if (tooltipText) {
        tooltipIcon = (
            <button type="button" className="info-button" onClick={onToggleTooltip}>
                <span className="ikon-info-24 label-icon" />
            </button>
        );
    } else if (modalHelpBody && modalHelpHeader) {
        tooltipIcon = (
            <span onClick={onToggleModal} onKeyDown={onToggleModal} className="info-button-wrapper">
                <Icon type={IconTypes.INFO_24} />
            </span>
        );
        modalBox = (
            <Modal
                headerText={modalHelpHeader}
                onClickCallback={onToggleModal}
                show={modalOpen}
                appNamespace={appNamespace}
                id="modal-box"
                onClose={onToggleModal}
            >
                {modalHelpBody}
            </Modal>
        );
    }
    return (
        <div className="radioknobs form-group" role="group" aria-labelledby={`${name}_${id}_group_label`}>
            <label id={`${name}_${id}_group_label`} className="control-label">
                {heading}
                {tooltipIcon}
            </label>

            {tooltipBox}
            {modalBox}
            <div>
                <div className={classNames('radioknob', { 'has-error error': errorText })}>
                    <input
                        className={classNames('form-control', { disabled: isDisabled }, className)}
                        onChange={onChange}
                        checked={value === values[0]}
                        type="radio"
                        id={`0_${name}`}
                        name={name}
                        value={values[0]}
                        disabled={isDisabled}
                    />
                    <label htmlFor={`0_${name}`} className={classNames('btn btn-primary', { disabled: isDisabled })}>
                        <span>{labels[0]}</span>
                    </label>
                </div>
                <div className={classNames('radioknob', { 'has-error error': errorText })}>
                    <input
                        className={classNames('form-control', { disabled: isDisabled }, className)}
                        onChange={onChange}
                        checked={value === values[1]}
                        type="radio"
                        id={`1_${name}`}
                        name={name}
                        value={values[1]}
                        disabled={isDisabled}
                    />
                    <label htmlFor={`1_${name}`} className={classNames('btn btn-primary', { disabled: isDisabled })}>
                        <span>{labels[1]}</span>
                    </label>
                </div>
                {errorText && <ErrorMessage text={errorText} />}
            </div>
        </div>
    );
};

RadioInput.propTypes = {
    appNamespace: string,
    id: string.isRequired,
    heading: string.isRequired,
    name: string.isRequired,
    onChange: func.isRequired,
    labels: arrayOf(string).isRequired,
    value: oneOfType([string, bool]),
    values: arrayOf(oneOfType([string, bool])).isRequired,
    className: string,
    errorText: string,
    isDisabled: bool,
};

export default React.memo(RadioInput);
